/*
 * @Author: zj 
 * @Date: 2019-04-22 11:15:14 
 * @Last Modified by: zj
 * @Last Modified time: 2021-09-24 16:41:23
 */
import request from '../request'

import login from './login'
import mytask from './mytask'
import findTask from './findTask'
import user from './user'
import Mock from 'mockjs'


export default {

    //登录注册模块
    login: login,

    //我的任务
    mytask: mytask,

    //发现问题
    findTask: findTask,

    //个人中心
    user: user,

    //清除所有缓存
    claer_all: function() { request.clear_all_cache() },

    mock: (para, suss, data)=>{

        setTimeout(()=>{
            suss({
                code: 0,
                msg: "success",
                ...Mock.mock({...data})
            })
        },100)

    },
    
    ajax: (url,type='post',para, suss, err) => request.request(url, para, type, () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined && typeof err == 'function') { return e => { err(e) } } else { return null } },'json'),

}


// WEBPACK FOOTER //
// ./src/api/account.js